// extracted by css-extract-rspack-plugin
export default {"tooltip":"ArticleSinglePriceCell_tooltip__s2ZZA","highlight":"ArticleSinglePriceCell_highlight__WxsfQ"};